import qs from "qs";
import _ from "lodash";
import axios from "axios";
import Cookies from "js-cookie";
import { USER_ACCESS_COOKIE, SUPER_USER_ACCESS_COOKIE, FIDELIZE_BROKER_FEATURES_COOKIE } from "@plataforma/utils";
import { clearAuthData } from '../../../../auth/src/clearAuthData';
import { USER_TYPE } from '@plataforma/utils';

const getRedirectUrl = (origin) => {
  return `${process.env.REACT_APP_PLATAFORMA_LOGIN}?redirectUrl=${origin ? encodeURI(origin) : ""
    }`;
};

const { token: authToken } = Cookies.getJSON("uac") || {};

class CoreAPI {
  constructor(baseURL, token = null) {
    this.baseURL = baseURL;
    this.token = token || authToken;
  }

  getInstance(contentType = "application/json") {
    const superUser = Cookies.getJSON(SUPER_USER_ACCESS_COOKIE) || null;
    const userAccess = Cookies.getJSON(USER_ACCESS_COOKIE) || null;

    const url = superUser === null ? this.baseURL : this.baseURL.replace('ms-plataforma-bff/', 'ms-plataforma-bff/superuser/');



    let config = {
      baseURL: url,
      headers: { "Content-Type": contentType },
    };

    if (userAccess?.userType === USER_TYPE.consultancy) {

      config = {
        baseURL: url,
        headers: { "Content-Type": contentType, "Broker-Login": userAccess?.broker?.user.userName },
      };
    }

    const instance = axios.create(config);
    instance.interceptors.request.use(CoreAPI.handleHeader);
    instance.interceptors.response.use(
      CoreAPI.handleSuccess,
      CoreAPI.handleError
    );
    instance.interceptors.request.use(function (config) {
      const token = authToken;
      if (!token) {
        window.location = getRedirectUrl(window.location.href);
        return config;
      }

      config.headers.Authorization = `Bearer ${token}`;
      return config;
    });

    return instance;
  }

  static handleHeader(request) {


    if (
      request &&
      request.data &&
      request.headers["Content-Type"] === "application/x-www-form-urlencoded"
    ) {
      request.data = qs.stringify(request.data);
    }
    return request;
  }

  static handleSuccess(error) {
    // Store.inProcess = false;
    return error;
  }

  static handleError(error) {
    const { userType, broker, brokerLogin } = Cookies.getJSON(USER_ACCESS_COOKIE) || {};
    // Store.inProcess = false;

    // if (error.message === 'Network Error') {
    //   Alert.error(
    //     'Sem conexão com a Internet. Por favor, verifique sua conexão e tente novamente.'
    //   );
    // }

    if (error.response && error.response.status === 401) {
      return new Promise((resolve, reject) => {
        const originalRequest = error.config;
        const authToken = Cookies.getJSON(USER_ACCESS_COOKIE) || {};

        if (!authToken || !authToken.refreshToken || !authToken.useRefreshToken) {
          window.location = getRedirectUrl(window.location.href);
        }

        const brokerLoginConsultancy =
          broker && broker.user && broker.user.userName ? broker.user.userName : brokerLogin;

        let headers = {
          'Content-Type': 'application/x-www-form-urlencoded',
          'app-version': process.env.REACT_APP_VERSION
        };

        if (userType === USER_TYPE.consultancy && brokerLoginConsultancy) {
          headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
            'app-version': process.env.REACT_APP_VERSION,
            'Broker-Login': brokerLoginConsultancy
          };
        }

        axios({
          method: 'post',
          url: `${process.env.REACT_APP_BASE_BFF}auth/api/account/v1/token/refresh`,
          headers,
          data: qs.stringify({ refresh_token: authToken.refreshToken })
        })
          .then(response => {
            const millisecondsToAddToCookieTime =
              response.data.refresh_expires_in || response.data.expires_in;
            const dateExpire = new Date(new Date().getTime() + millisecondsToAddToCookieTime * 1000);

            Cookies.set(
              USER_ACCESS_COOKIE,
              {
                ...authToken,
                token: response.data.access_token,
                expiresIn: response.data.expires_in * 1000,
                refreshToken: response.data.refresh_token,
                refreshExpiresIn: response.data.refresh_expires_in * 1000,
                createAt: new Date().toISOString()
              },
              {
                expires: dateExpire,
                domain: `${process.env.REACT_APP_DOMAIN}`
              }
            );
            // update fidelize features cookie with same expiry of user access
            Cookies.set(
              FIDELIZE_BROKER_FEATURES_COOKIE,
              Cookies.getJSON(FIDELIZE_BROKER_FEATURES_COOKIE),
              {
                expires: dateExpire,
                domain: `${process.env.REACT_APP_DOMAIN}`
              }
            );
            originalRequest.headers.Authorization = `${authToken.tokenType} ${response.data.access_token}`;

            resolve(axios(originalRequest));
          })
          .catch(async () => {
            await clearAuthData();
            if (window.location !== getRedirectUrl(window.location.href)) {
              window.location = getRedirectUrl(window.location.href);
            }
            reject();
          });

        return Promise.reject(error);
      });
    }

    if (error && error.response && error.response.status === 500) {
      error.response.message =
        "Houve algum problema com os nossos serviços. Por favor, tente novamente";
    }

    return Promise.reject(error.response || error);
  }
}

export const capitalizeResponse = (data) => {
  const result = _.mapKeys(data, (v, k) => _.startCase(k).replace(/\s/g, ""));
  return result;
};

export const generateQueryString = (params) => {
  if (params && Object.keys(params).length) {
    return qs.stringify(params, { addQueryPrefix: true });
  }
  return "";
};

export default CoreAPI;
